export default __webpack_public_path__ + "static/media/ShopAmericaLogo.913ebf04.png";